import React from 'react';
import { AppRoutes } from './components/appRouting/AppRoutes';

export const App = () => <AppRoutes />;
